import { CommonModule } from '@angular/common';
import { Component, ComponentFactoryResolver, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterLink, RouterLinkActive, RouterModule, RouterOutlet, Event as RouterEvent } from '@angular/router';

import { Subscription, async, filter } from 'rxjs';
import { Balance, WalletInfo } from '../../source/modules/cashier/balance';
import { Store } from '@ngrx/store';
import { SlotsService } from '../../source/services/slotsservice/slots.service';
import { PlayerService } from '../../source/services/player/player.service';
import * as loginActions from '../../source/appstates/loginstates/loginActions'
import * as appState from '../../source/appstates/appState'
import * as cashierActions from '../../source/appstates/cashierstates/cashierActions'
import { LoginState } from '../../source/appstates/loginstates/loginState';
import { PlayerGetProfile } from '../../source/appstates/playerstates/playerActions';
import { ProfileState } from '../../source/appstates/playerstates/playerState';
import { CashierState } from '../../source/appstates/cashierstates/cashierState';
import { QuickloginComponent } from '../quicklogin/quicklogin.component';
import { NgxMarqueeModule } from 'ngx-marquee';
import { FooterComponent } from '../footer/footer.component';
import { GamesService } from '../../source/services/games/games.service';
import { QRCodeModule } from 'angularx-qrcode';
import { CommondataService } from '../../source/services/games/commondata.service';
import { FormsModule } from '@angular/forms';
import { FooterProviderComponent } from '../../footer-provider/footer-provider.component';
import { AllGameproviderComponent } from '../../all-gameprovider/all-gameprovider.component';
import { HistoryPageComponent } from '../history-page/history-page.component';
import { Profile } from '../../source/modules/player/profile';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { timer, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoginService } from '../../source/services/login/login.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
declare var $: any;
@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, TranslateModule, FooterComponent, FooterProviderComponent, AllGameproviderComponent, QRCodeModule, RouterModule, FormsModule, RouterOutlet, RouterLink, NgxMarqueeModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Output() close = new EventEmitter<void>();
  @ViewChild("profileDropdown") profileDropdown!: ElementRef;
  urlSafe: SafeResourceUrl | null = null;
  private destroy$ = new Subject<void>();
  logoutPopup: boolean = false;
  Appmenu!: boolean;
  openProfile: boolean = false;
  allproiderGames: boolean = false;
  showPopupHot = false;
  showPopupSports = false;
  showPopupcasino = false;
  showPopupInstant = false;
  isOpenTermsAndCondition: boolean = false;
  isPrivacyPolicy: boolean = false;
  isTermsAndCondition: boolean = false;
  popupType: string = '';
  isPopupOpen = false;
  selectedAvtarId: any;
  private storeSub!: Subscription;
  private closeSub!: Subscription;
  showCopiedMessage = false;
  selectedTab: string = 'casino';
  private storeProfileSub!: Subscription;
  playerName: any;
  indexId: any = 1000;
  cashier!: Balance;
  walleteInfo: WalletInfo[] = [];
  balance: any;
  userCompoints: any;
  lightTheme: boolean = false;
  playertype: any;
  playerLoggedIn: boolean = false;
  menuNames: boolean = true;
  openRegister: boolean = false;
  HandleRegSuccess: boolean = false;
  casinomessage: string = '';
  previewAvtar: string = "";
  casinogamessuccessPop: boolean = false;
  openClo: boolean = false;
  menushow: boolean = false;
  shodrop: any;
  closeMenuCoverDiv: boolean = false;
  sessionExpiresuccessPop: boolean = false;
  sessionmessage: string = "";
  @ViewChild('alertHost', { read: ViewContainerRef }) alertHost!: ViewContainerRef;
  showDiv: boolean = true;
  loginSub!: Subscription;
  profileHeader: boolean = false;
  profileAvathar: boolean = false;
  cashuser: any;
  bounsuser: any;
  providerList2: any;
  providerList: Set<string> = new Set();

  hidedeposit: boolean = false
  hidecashout: boolean = false
  statusMessage: boolean = true;
  isDepositMesPop: boolean = false;
  gadgetType: any;
  showAvtars: boolean = false;
  isOpenIosPop: boolean = false;
  ismobile: boolean = false;
  currentActiveIndex: number = 0;
  showProvider: boolean = false;
  activeMenu: string = '';
  selectedLang: any = localStorage.getItem('lang') || 'BN'
  openClose: boolean = false
    ; languages = [
      { code: 'EN', label: 'English' },
      { code: 'BN', label: 'Bangla' }
    ];
  @ViewChild('avatarDropdown', { static: false }) avatarDropdownRef!: ElementRef;
  @ViewChild('balanceDropdown', { static: false }) balanceDropdownRef!: ElementRef;
  links: Array<any> = [
    { name: 'MENU', active: false, icon: 'fa-bars', router: 'MENU' },
    // { name: 'Back', active: false, icon: 'fa-arrow-left', router: 'menu' },
    { name: 'SEARCH', active: false, icon: 'fas fa-search' },
    { name: 'HOME', active: true, icon: 'fa-home', router: 'home' },
    { name: 'SLOTS', active: false, icon: 'fa-quidditch', router: 'slots' },
    { name: 'AVIATOR', active: false, icon: 'fa-futbol', router: 'aviator' },
    // { name: 'SEARCH', active: false, icon: 'fa-search', router: 'sports'  },
  ];
  profile!: Profile;
  gifLoader: boolean = false
  searchProvider: any;
  referFriend: any;
  avatarList: any;
  errorMsg: any;
  vipLevels: any[] = [];
  vipName: any;
  vipName1: any;
  playerStatisticsSec: boolean = false;
  currentRank: any = 'Unranked';
  nextRankIcon: any = 'Bronze';
  vipProgress: any = 0;
  playerStatistics: any = [];
  clanIframePop: boolean = false;
  isLoading: boolean = false;
  isExchange: boolean = false;
  provider: any;
  sportspermition: boolean = true;


  isApkDownload: boolean = true
  constructor(private store: Store<appState.AppState>,
    private componentFactoryResolver: ComponentFactoryResolver,
    private slotsService: SlotsService,
    private gamesService: GamesService,
    private PlayerService: PlayerService,
    private loginService: LoginService,
    public sanitizer: DomSanitizer,
    public router: Router, private gameService: GamesService, private comman: CommondataService, private translate: TranslateService) {
    const lang: any = localStorage.getItem('lang');
    if (lang) {
      this.translate.setDefaultLang(lang);
      this.translate.use(lang);
    } else {
      localStorage.setItem('lang', 'BN')
      this.translate.setDefaultLang('BN');
      this.translate.use('BN');
    }
    const params1 = new URLSearchParams(window.location.search);
    console.log(params1)
    var urlTokenForgot = params1.get('token');
    var urlEventTypeForgot = params1.get('eventType');
    console.log(params1, urlTokenForgot, urlEventTypeForgot)
    if (urlEventTypeForgot == 'registration') {
      let payload = {
        "token": urlTokenForgot,
        "face": "pkrmaster",
        "language": 'en'
      }
      this.loginService.verifyAccount(payload).subscribe((data: any) => {
        this.router.navigate(['/home'])
        if (data['success'] == true) {
          this.casinogamessuccessPop = true
          this.casinomessage = "E-mail verified successfully. Happy Playing !!!"

        } else if (data['success'] == false) {
          this.casinogamessuccessPop = true
          this.casinomessage = data.description

        }
      })
    }
    this.comman.showProviderGames$.subscribe(value => {
      this.statusMessage = value;
    });
  }
  ngOnInit() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (window.innerWidth <= 850) {
          this.updateActiveRoute();
        }
      });
    this.updateActiveRoute();
    var selectColor = localStorage.getItem('color')
    if (selectColor) {
      this.setTheme(selectColor)
    }
    setTimeout(() => {
      this.showProvider = true;
    }, 2500)
    this.detectAndroid()
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    var url = window.location.href;
    let url2 = url.split('wsession=')[1];
    if (url2) {
      var body: any = {
        "success": true,
        "sessionId": url2
      }
      this.store.dispatch(new loginActions.LoginSuccess(body));
    }
    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    this.gadgetType = isMobile ? "Phone" : "Desktop";

    this.storeSub = this.store.select("loginState").subscribe((loginState: LoginState) => {
      if (loginState?.playerLoggedIn) {
        if (loginState.playerLoggedIn.loggedIn) {
          this.playerLoggedIn = loginState.playerLoggedIn.loggedIn;
          this.store.dispatch(new cashierActions.CashierGetBalanceStart());
          this.getBalance()
          this.Profile()
          this.gifLoader = true;
          this.PlayerService.onPlayerGetProfile().subscribe(data => {
            //  this.gamesService.fetchAllGames11(data)
            localStorage.setItem("playerProfileName", data.login)
            if (data.deposits == false) {
              this.hidedeposit = false;
              sessionStorage.setItem("Dp", "false")
            } else {
              this.hidedeposit = true;
              sessionStorage.setItem("Dp", "true")
            }
            if (data.withdrawal == false) {
              this.hidecashout = false;
              sessionStorage.setItem("widl", "false")
            } else {
              this.hidecashout = true;
              sessionStorage.setItem("widl", "true")
            }
          });
        } else {
          this.playerLoggedIn = false;
          // this.gamesService.fetchAllGames11(false)
        }
      }
      if (loginState.forgotPasswordResponse) {
        if (loginState.forgotPasswordResponse.success === true) {
          this.casinomessage = "Password sent successfully to the registered Email ID";
          this.casinogamessuccessPop = true;
        }
      }
    })
    timer(0, 5000)
      .pipe(
        takeUntil(this.destroy$),
        filter(() => this.playerLoggedIn)
      )
      .subscribe(() => {
        this.store.dispatch(new cashierActions.CashierGetBalanceStart());
        this.getBalance();
        this.slotsService.btisportsjsfile();
      });
    if (this.router.url.indexOf('/register') !== -1 || this.router.url.indexOf('/referrer') !== -1) {
      setTimeout(() => {
        const queryString = window.location.href;
        const urlParams = new URL(queryString).searchParams;
        const productID = urlParams.get('ID');
        if (productID) {
          localStorage.setItem('referrer', productID)
        }
        if (this.playerLoggedIn == false) {
          this.showPopUp('REGISTER');
        } else {
        }
      }, 1000);
    }
    this.storeSub = this.store.select("cashierState").subscribe(
      (cashierState: CashierState) => {
        if (cashierState.sessionexpire) {
          if (cashierState.sessionexpire.session) {
            this.sessionmessage = "Your session has expired. Please relogin";
            this.sessionExpiresuccessPop = true;
          } else { }
        }
      });
    const cleanPath = window.location.pathname.slice(1);
    this.activeMenu = cleanPath
    this.getMenuFromPath(this.activeMenu)
    this.router.events
      .pipe(
        filter((event: RouterEvent): event is NavigationEnd => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        // var activeCls = this.comman.getPreviousUrl()
        const url = event.urlAfterRedirects || event.url;
        if (url.includes('/GameLaunch')) {
          this.allproiderGames = false;
        } else {
          // this.allproiderGames = true;

        }
        if (url === '/sports') {
          this.selectedTab = 'sports';
        } else {
          this.selectedTab = 'casino';
        }
      });
    this.getActiveProviders();

    this.gamesService.games$.subscribe((data: any) => {
      if (!data) return;

      this.sportspermition = data.filter((data: any) => data.status)
    })
  }

    detectAndroid() {
    const isAndroid = /Android/i.test(navigator.userAgent);
    const isCordova =
      typeof (window as any).cordova !== 'undefined';
    this.isApkDownload = isAndroid && !isCordova;;
  }
  getActiveProviders() {
    this.gamesService.providerList$.subscribe((res: any) => {
      if (res) {
        this.providerList = res
        console.log(this.providerList, "+_+++++++++++++++++++++++++++++++++++++++")
      }
    })
  }
  getMenuFromPath(url: string) {
    if (!this.playerLoggedIn && url === "vip-program") {
      this.showPopUp("LOGIN");
    } else if (url == 'vip-program') {
      this.isExchange = !this.isExchange
    } else {
      this.activeMenu = url
      localStorage.removeItem('P_R_N');
    }
  }
  myprofile() {
    this.openProfile = !this.openProfile;
    if (this.openProfile) {
      setTimeout(() => {
        this.scrollToDown();
      }, 100);
    }
  }
  scrollToDown() {
    if (this.profileDropdown) {
      this.profileDropdown.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'end'
      });
    }
  }

  ngAfterViewChecked() {
    if (window.location.hostname != 'localhost') {
      console.clear();
    }
    let logkey = sessionStorage.getItem('logkey')
    if (logkey) {

    } else {
      // console.clear();
    }
    if (this.router.url == '/home?status=Created' || this.router.url == 'home?status=Created') {
      console.log(this.router.url, "kkkkkkkkkkkkkkkkkkk")
      this.comman.close()
    }
  }

  onDeposit() {
    if (this.gadgetType == 'Desktop') {
      this.isDepositMesPop = true;
    } else {
      this.router.navigate(['/deposit'])
    }
  }
  Profile() {
    this.store.dispatch(new PlayerGetProfile());
    this.storeSub = this.store.select("playerState").subscribe(
      (playerState: ProfileState) => {
        if (playerState.profile) {
          this.profile = playerState.profile;

        }
      });
    this.PlayerService.onPlayerGetPlayerLevels().subscribe((data: any) => {
      if (data) {
        this.vipLevels = data.playerLevelResponses;
        for (let i = 0; i < this.vipLevels.length; i++) {
          this.vipName = this.vipLevels[i].name;
          sessionStorage.setItem('vip', this.vipName)
          this.vipName1 = this.vipLevels[i].priority;
        }
      }
    });

  }
  getBalance() {
    this.storeSub = this.store.select("cashierState").subscribe(
      (cashierState: CashierState) => {
        if (cashierState.sessionexpire) {
          if (cashierState.sessionexpire.session) {
            this.sessionmessage = "Your session has expired. Please relogin";
            
            this.sessionExpiresuccessPop = true;
          }
        };
        if (cashierState.balance) {
          if (cashierState.balance.values) {
            this.walleteInfo = cashierState.balance.values;
            for (let wallet of this.walleteInfo) {
              if (wallet.symbol) {
                this.gifLoader = false;
                this.cashuser = wallet.cash.value;
                this.bounsuser = wallet.bonus.value;
                sessionStorage.setItem("cashuser", this.cashuser)
                sessionStorage.setItem("bounsuser", this.bounsuser)
                this.balance = Number(wallet.cash.value + wallet.bonus.value).toFixed(2);
                sessionStorage.setItem("balance", this.balance)
                sessionStorage.setItem("symbol", wallet.symbol[0])
                sessionStorage.setItem("wallet", wallet.wallet.name)
                this.playertype = wallet.symbol;
              }
              if (wallet.wallet.name === "COMPPOINTS") {
                let comp = (wallet.cash.value).toFixed(2)
                this.userCompoints = comp || 0;
              }
            }
          };
        }
      }
    )
  }



  ngOnDestroy() {
    if (this.closeSub) {
      this.closeSub.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }


  showRegisterPopUp() {
    this.openRegister = true;
  }

  showPopUp(value: string) {
    this.store.dispatch(new loginActions.ResetState());

    const alertCmpFactory = this.componentFactoryResolver.resolveComponentFactory(
      QuickloginComponent
    );
    const hostViewContainerRef = this.alertHost;
    hostViewContainerRef.clear();
    const componentRef = hostViewContainerRef.createComponent(alertCmpFactory);
    componentRef.instance.formState = value;
    componentRef.instance.providerObj = this.provider;

    this.closeSub = componentRef.instance.close.subscribe(() => {
      this.closeSub.unsubscribe();
      hostViewContainerRef.clear();
    });
  }
  showLogOutPopup() {
    this.logoutPopup = true;
  }
  hideLogOutPopup() {
    this.logoutPopup = false;
  }
  onClickLogout() {
    // sessionStorage.clear();
    this.router.navigate(['/']);
    this.logoutPopup = false;
    this.store.dispatch(new loginActions.ResetState());
    this.store.dispatch(new cashierActions.ResetState());
    this.store.dispatch(new loginActions.LogoutStart());
    localStorage.removeItem('affcheckid')
    localStorage.removeItem('affCid')
    this.gameService.providerListSubject.next([])
    setTimeout(() => {
      window.location.reload();
    }, 800);
    this.closeGameSession()
  }
  closeGameSession() {
    this.slotsService.endsession().subscribe(data => { })
    let gameSession = sessionStorage.getItem("closeGameSession")
    let body = {
      "gameSession": gameSession
    }

    if (gameSession) {
      this.slotsService.closeGameSession(body).subscribe((res: any) => {
        console.log(res.success)
        if (res.success) {
          sessionStorage.removeItem("closeGameSession")
        }

      })
    }
  }
  indexValue(i: any) {
    if (i == this.indexId) {
      this.indexId = 1000;
    } else {
      this.indexId = i;
      this.shodrop = !this.shodrop;
    }
  }


  closeMenuNames(data: any) {
    this.closeMenuCoverDiv = false;
    this.getMenuFromPath('home');
    if (window.innerWidth <= 767 && data !== 'My Account' && data !== 'Cashier') {
      this.menuNames = true;
    } else {
      if (window.innerWidth <= 767) {
        this.menuNames = false;
      }
    }

  }



  openMenu() {
    this.menuNames = !this.menuNames;
    if (window.innerWidth <= 767) {
      this.closeMenuCoverDiv = true;
    }
  }

  openarcades(data: any) {
    window.open(data.arcades_GAME_LAUNCH_URL)
  }
  casinogamessuccessPopClose() {
    this.casinomessage = '';
    this.casinogamessuccessPop = false;
  }
  sessionExpiresuccessPopClose() {
    this.router.navigate(['/']);
    this.onClickLogout();
    this.sessionExpiresuccessPop = false;
    this.sessionmessage = "";
    setTimeout(() => {
      window.location.reload();
    }, 800);
  }
  setTheme(data: any) {
    localStorage.setItem('color', data)
    if (data == 'lightTheme') {
      this.lightTheme = true;
    } else {
      this.lightTheme = false;
    }
    let body = document.getElementsByTagName('body')
    body[0].className = ''
    body[0].classList.add(data);
  }

  ngAfterViewInit() {
    $('#carouselExampleIndicators').carousel();
  }

  openIosPop() {
    this.isOpenIosPop = true;
  }
  onCloseIosPop() {
    this.isOpenIosPop = false;
  }
  openPopup(type: string) {
    this.closeAllPopups(); // Close all popups first
    if (type === 'casino') this.showPopupcasino = true;
    if (type === 'instant') this.showPopupInstant = true;
    if (type === 'hot') this.showPopupHot = true;
    if (type === 'sports') this.showPopupSports = true;
  }

  closePopup(type: string) {
    setTimeout(() => {
      if (type === 'casino') this.showPopupcasino = false;
      if (type === 'instant') this.showPopupInstant = false;
      if (type === 'hot') this.showPopupHot = false;
      if (type === 'sports') this.showPopupSports = false;
    }, 100);
  }

  keepPopupOpen(type: string) {
    if (type === 'casino') this.showPopupcasino = true;
    if (type === 'instant') this.showPopupInstant = true;
    if (type === 'hot') this.showPopupHot = true;
    if (type === 'sports') this.showPopupSports = true;
  }

  closeAllPopups() {
    this.showPopupcasino = false;
    this.showPopupInstant = false;
    this.showPopupHot = false;
    this.showPopupSports = false;
  }
  updateActiveRoute(): void {
    const currentRoute = this.router.url.split('/')[1]; // Get the route after the base URL
    this.links.forEach((link, i) => {
      link.active = (link.router === currentRoute); // Set active link 
      if (link.router === currentRoute) {
        this.currentActiveIndex = i; // Update the active index
      }
    });
    console.log(this.links)
  }
  onLinkClick(index: number): void {
    window.scroll(0, 0);
    if (index === 0) {
      this.menushow = !this.menushow;
      if (this.menushow) {
        this.links[0].name = 'BACK';
        this.links[0].icon = 'fa-arrow-left';
        this.links.forEach((link, i) => {
          link.active = (i === index);
        });
      } else {
        this.links[0].name = 'MENU';
        this.links[0].icon = 'fa-bars';
        this.links[0].active = false
        this.links.forEach((link, i) => {
          link.active = (i === index);
        });
      }

      return;
    } else if (index == 1) {
      this.proiderGamesAll()
    } else {
      console.log(index)
      this.closeMenu()
      if (this.links[index].router !== this.router.url.split('/')[1]) {
        this.router.navigate([`/${this.links[index].router}`]);
      }
      this.links.forEach((link, i) => {
        link.active = (i === index);
      });
    }
    this.currentActiveIndex = index;
    this.links[0].name = 'MENU';
    this.links[0].icon = 'fa-bars';
    this.menushow = false;
  }

  routerLink(index: any) {
    localStorage.setItem('provider', index)
    this.comman.setValue(index);
    this.router.navigate(['/slots'])
  }
  closeMenu(): void {
    this.menushow = false;
    this.links[0].name = 'MENU';
    this.links[0].icon = 'fa-bars';
    localStorage.removeItem('P_R_N')
  }


  redirect(data: any) {
    this.router.navigate([`/${data}`])
    this.closeAllPopups()
  }
  onCloseTermsAndCondition() {
    this.isOpenTermsAndCondition = false;
    this.isTermsAndCondition = false
    this.isPrivacyPolicy = false
    this.router.navigate(['/home'])

  }
  copyMessage(val: string) {
    const tempTextarea = document.createElement('textarea');
    tempTextarea.value = val;
    document.body.appendChild(tempTextarea);
    tempTextarea.select();
    tempTextarea.setSelectionRange(0, tempTextarea.value.length);
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        this.showCopiedMessage = true;
        setTimeout(() => {
          this.closeMenu()
          this.showCopiedMessage = false;
        }, 2000);
      }
    } catch (err) {
      console.error('Error copying text: ', err);
    }
    document.body.removeChild(tempTextarea);
  }
  filterGamesProvider(): void {
    this.comman.setSearchTerm(this.searchProvider);
    this.router.navigate(['/slots'])

  }

  toggleDropdown(event: MouseEvent): void {
    event.stopPropagation();
    this.profileAvathar = false;
    this.profileHeader = !this.profileHeader;
  }

  toggleDropdownAvathar(event: MouseEvent): void {
    event.stopPropagation();
    this.profileHeader = false;
    this.profileAvathar = !this.profileAvathar;
  }

  onChangeAvtar(e: any) {
    this.showAvtars = !this.showAvtars;
    this.toggleDropdownAvathar(e);
  }

  selectAvtar(avtar: any) {
    this.selectedAvtarId = avtar.id;
    this.previewAvtar = "data:image/png;base64," + avtar.imageData;
  }

  setAvtar() {
    // alert("hitr")
  }

  openLiveSupport() {
    if (window && (window as any).Tawk_API) {
      (window as any).Tawk_API.maximize();
    } else {
      console.warn('Tawk_API is not available yet.');
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent | Event): void {
    const clickedInsideAvatar = this.avatarDropdownRef?.nativeElement.contains(event.target);
    const clickedInsideBalance = this.balanceDropdownRef?.nativeElement.contains(event.target);

    if (!clickedInsideAvatar) this.profileAvathar = false;
    if (!clickedInsideBalance) this.profileHeader = false;
  }
  proiderGamesAll() {
    this.allproiderGames = true;
  }
  proiderGamesClose() {
    this.allproiderGames = false;
  }

  onOpenPlayerStatistics() {
    this.playerStatisticsSec = !this.playerStatisticsSec;
    this.PlayerService.getPlayerStatistics().subscribe((res) => this.playerStatistics = res);


    this.PlayerService.onPlayerGetPlayerLevels().subscribe((data: any) => {
      if (data) {
        // this.vipLevels = data.playerLevelResponses.sort((a: any, b: any) => a.priority - b.priority);
        this.vipLevels = data.playerLevelResponses
          .sort((a: any, b: any) => a.priority - b.priority)
          .map((level: any) => {
            if (level.name === "Platinum") {
              level.name = "Platinum1";
            } else if (level.name === "Active") {
              level.name = "Platinum2";
            } else if (level.name === "Shark") {
              level.name = "Platinum3";
            }
            return level;
          });

        let totalLevels = this.vipLevels.length;
        let step = totalLevels > 1 ? 100 / (totalLevels - 1) : 100;
        // console.log(this.vipLevels)
        for (let ele of this.vipLevels) {
          if (this.userCompoints >= ele.compPoints) {
            this.vipName = ele.name;
            this.vipName1 = ele.priority;
          }
        }
        console.log(this.vipName)
        const currentRankName = this.vipName || this.vipLevels[0].name;
        this.currentRank = currentRankName === "Iron" ? "Unranked" : currentRankName;

        let nextLevelIndex = this.vipLevels.findIndex((level) => level.name === currentRankName);
        if (nextLevelIndex + 1 < this.vipLevels.length) {
          this.nextRankIcon = this.vipLevels[nextLevelIndex + 1].name;
        } else {
          this.nextRankIcon = "Top Level";
        }

        let minPoints = 0;
        let maxPoints = Infinity
        for (let i = 0; i < this.vipLevels.length; i++) {
          if (this.vipLevels[i].name === this.vipName) {
            minPoints = this.vipLevels[i]?.compPoints || 0;
            maxPoints = this.vipLevels[i + 1]?.compPoints || this.vipLevels[this.vipLevels.length - 1]?.compPoints
          }
        }

        function calculatePercentage(minPoints: number, maxPoints: number, currentPoints: number): number {
          if (maxPoints === minPoints) {
            return 0;
          }

          const percentage = ((currentPoints - minPoints) / (maxPoints - minPoints)) * 100;
          return Math.max(0, Math.min(percentage, 100));
        }

        setTimeout(() => {
          const result = calculatePercentage(minPoints, maxPoints, this.userCompoints);
          console.log(result.toFixed(2) + "%");
          this.vipProgress = result.toFixed(2)
        }, 1000);
      }
    });
  }

  onLaunchClan() {
    this.isLoading = true;
    this.clanIframePop = true;
    this.PlayerService.generateTokenClanApi().subscribe(res => {
      const { message, token } = res;
      if (message === "success") {
        this.urlSafe = this.sanitizer
          .bypassSecurityTrustResourceUrl(token);
      }
      this.isLoading = false;
    });
  }
  changeLanguage(lang: any, event: Event) {
    event.stopPropagation();
    this.openClose = false;
    localStorage.setItem('lang', lang)
    this.selectedLang = lang;
    this.translate.use(lang);
    console.log(this.openClose)
  }
  toggleDropdown1() {
    this.openClose = !this.openClose;
    console.log(123321213)
    // if (this.openClose) {
    //   setTimeout(() => {
    //     window.scrollTo({
    //       top: document.documentElement.scrollHeight,
    //       behavior: 'smooth'
    //     });
    //   }, 150);
    // }
  }
} 
